module.exports = __webpack_public_path__ + "static/media/detalle-rojo.97b2493f.svg";